define(function() {
  return window;  // real global window object
});